<template>
  <v-container class="py-y">
    <v-row justify="end">
      <v-col class="py-0">
        <v-container class="pt-0">
          <v-row justify="end">
            <uppload-btn @uploadComplete="onUploadComplete">
              <template slot-scope="{ on }">
                <v-btn color="pink" @click="on" dark fab small>
                  <v-icon>mdi-cloud-upload</v-icon>
                </v-btn>
              </template>
            </uppload-btn>
          </v-row>
        </v-container>
      </v-col>
    </v-row>
    <v-divider />
    <v-row>
      <v-col>
        <draggable v-model="images" @end="onDragEnd">
          <transition-group tag="div" class="grid" name="grid">
            <v-img
              class="cell"
              v-for="item in images"
              :key="item.name"
              :src="item.url"
            >
              <v-btn
                dark
                icon
                @click="onImageRemove(item)"
                color="pink"
                fab
                small
              >
                <v-icon small>close</v-icon>
              </v-btn>
              <template v-slot:placeholder>
                <v-row class="fill-height ma-0" align="center" justify="center">
                  <v-progress-circular
                    indeterminate
                    color="grey lighten-5"
                  ></v-progress-circular>
                </v-row>
              </template>
            </v-img>
          </transition-group>
        </draggable>
      </v-col>
    </v-row>
    <v-row v-if="debug"
      ><v-col>
        <code> {{ value }} == {{ images }} </code>
      </v-col></v-row
    >
  </v-container>
</template>

<script>
import draggable from "vuedraggable";
import UpploadBtn from "../contents/UpploadBtn";
export default {
  name: "images",

  props: {
    value: {
      type: Array,
      default: () => [],
    },
    ownerId: {
      type: String,
      default: () => "",
    },
  },

  components: {
    UpploadBtn,
    draggable,
  },

  data() {
    return {
      debug: false,
      images: this.value ? [...this.value] : [],
    };
  },

  watch: {
    value(newVal) {
      this.images = newVal ? [...newVal] : [];
    },
  },

  methods: {
    onUploadComplete(payload) {
      if (payload.success) {
        this.images.push({ name: payload.filename, url: payload.fileURL });
        this.$emit("input", [...this.images]);
      }
    },
    onDragEnd() {
      this.$emit("input", [...this.images]);
    },
    onImageRemove(payload) {
      this.images = this.images.filter((img) => img.name != payload.name);
      this.$emit("input", [...this.images]);
    },
  },
};
</script>

<style>
.grid {
  display: grid;
  grid-template-columns: repeat(4, auto);
  /*grid-template-rows: repeat(4, 100px);*/
  grid-gap: 0.4em;
}

.grid-move {
  transition: all 0.3s;
}

.cell {
  justify-content: end;
  align-items: start;
}
</style>



// WEBPACK FOOTER //
// src/components/gt/shared/images/Images.vue